import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { PageTabRail } from '../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../components/router/router-tabbed-navigation';
import {
  RaglCashBlotterTable,
  type RaglCashBlotterTableHeaderProps,
  type RaglCashBlotterTableViewContext,
} from '../../../../../../../../features/clearing-ledger/delta/ragl-cash-blotter-table';
import { getPageHead } from '../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/cash-blotter')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsReporting,
      label: 'Cash Blotter',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsReporting>,
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'cash-blotter',
        label: 'Reports',
        to: '/clearing/operations/reporting/cash-blotter',
      }),
    }) satisfies AggregateBreadcrumb,
  head: () => getPageHead('Cash Blotter'),
  component: CashBlotter,
});

function TableHeader({ filter }: RaglCashBlotterTableHeaderProps) {
  return <PageTabRail actions={filter} group={TabbedNavigationGroup.ClearingOperationsReporting} />;
}

const VIEW_CONTEXT: RaglCashBlotterTableViewContext = { kind: 'blotter' };

function CashBlotter() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <RaglCashBlotterTable HeaderActions={TableHeader} viewContext={VIEW_CONTEXT} />
      </PageLayout.Section>
    </PageLayout>
  );
}
